module.exports = __webpack_public_path__ + "static/media/woman.5d765080.png";